import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

/**
 * Component to test different types of errors for our error logger
 */
export const ErrorTest = () => {
  const [count, setCount] = useState(0);

  // Runtime error - accessing property of undefined
  const triggerRuntimeError = () => {
    const obj = undefined;
    console.log(obj.property); // This will cause a runtime error
  };

  // Promise rejection - unhandled promise rejection
  const triggerPromiseError = () => {
    new Promise((_, reject) => {
      reject(new Error('Test promise rejection'));
    });
  };

  // React error - invalid component rendering
  const triggerReactError = () => {
    // This will cause a React error by rendering an invalid element
    setCount(count + 1);
    // Force render an invalid element type
    const InvalidComponent = null;
    ReactDOM.render(<InvalidComponent />, document.createElement('div'));
  };

  return (
    <Card className="p-4 max-w-md mx-auto my-8">
      <h2 className="text-xl font-bold mb-4">Error Logger Test</h2>
      <div className="flex flex-col gap-3">
        <Button 
          variant="destructive" 
          onClick={triggerRuntimeError}
          className="w-full"
        >
          Trigger Runtime Error
        </Button>
        
        <Button 
          variant="destructive" 
          onClick={triggerPromiseError}
          className="w-full"
        >
          Trigger Promise Rejection
        </Button>
        
        <Button 
          variant="destructive" 
          onClick={triggerReactError}
          className="w-full"
        >
          Trigger React Error
        </Button>
      </div>
    </Card>
  );
};

export default ErrorTest;
